thisSymbolValue